var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0426 11.7525L10.0126 9H7.98011L4.95011 11.7525C4.10261 12.5175 3.82511 13.695 4.23761 14.76C4.65011 15.8175 5.65511 16.5 6.78761 16.5H11.2051C12.3451 16.5 13.3426 15.8175 13.7551 14.76C14.1676 13.695 13.8901 12.5175 13.0426 11.7525ZM10.3651 13.605H7.63511C7.35011 13.605 7.12511 13.3725 7.12511 13.095C7.12511 12.8175 7.35761 12.585 7.63511 12.585H10.3651C10.6501 12.585 10.8751 12.8175 10.8751 13.095C10.8751 13.3725 10.6426 13.605 10.3651 13.605Z",
    fill: "#F79009"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7625 3.24C13.35 2.1825 12.345 1.5 11.2125 1.5H6.7875C5.655 1.5 4.65 2.1825 4.2375 3.24C3.8325 4.305 4.11 5.4825 4.9575 6.2475L7.9875 9H10.02L13.05 6.2475C13.89 5.4825 14.1675 4.305 13.7625 3.24ZM10.365 5.4225H7.635C7.35 5.4225 7.125 5.19 7.125 4.9125C7.125 4.635 7.3575 4.4025 7.635 4.4025H10.365C10.65 4.4025 10.875 4.635 10.875 4.9125C10.875 5.19 10.6425 5.4225 10.365 5.4225Z",
    fill: "#F79009"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pending-icon.610142f84b844a52ed5345e6b7360a03.svg";
export { ForwardRef as ReactComponent };